module.exports = __webpack_public_path__ + "img/money-wave.7b06522f.svg";